export const labels = new Map();

export const ModelTypes = {
  AudioParameters: 'audio-parameters',
  Feature: 'features',
  FeatureEvidFunction: 'feature-evid-functions',
  FeatureService: 'feature-services',
  FeatureEvidTimer: 'feature-evid-timers',
  FeatureEvidVid: 'feature-evid-vids',
  FeatureGgwImplementations: 'feature-ggw-implementations',
  FeatureGgwDeviceType: 'feature-ggw-devices',
  FeatureUnit: 'feature-units',
  FeaturePort: 'feature-ports',
  FeatureParameters: 'feature-parameters',
  FeatureGgwFixedRoutes: 'feature-ggw-fixed-routes',
  FeatureGgwDynamicRouteTemplates: 'feature-ggw-dynamic-route-templates',
  FeatureEvidMonitoredVidSetups: 'feature-evid-monitored-vid-setups',
  FeatureOptionTokens: 'feature-option-tokens',
  FeatureAvodCatalogs: 'feature-avod-catalogs',
  GgwImplementationType: 'ggw-implementation-types',
  GgwDeviceType: 'ggw-device-types',
  GgwFixedRoute: 'ggw-fixed-routes',
  Parameter: 'parameters',
  Port: 'ports',
  Service: 'services',
  Unit: 'units',
  GuiZone: 'gui-zones',
  ProjectFeature: 'project-features',
  ProjectUnit: 'project-units',
  ProjectParameter: 'project-parameters',
  ProjectService: 'project-services',
  ProjectGgwDevice: 'project-ggw-devices',
  ProjectGgwDynamicRouteTemplate: 'project-ggw-dynamic-route-templates',
  ProjectEvidFunctions: 'project-evid-functions',
  HwZone: 'hw-zones',
  ProjectAvodCatalogs: 'project-avod-catalogs'
};

labels.set(ModelTypes.ProjectFeature, {
  one: 'Feature',
  many: 'Features',
  matchingPropertyNames: ['project-features', 'project-feature', 'features'],
});

labels.set(ModelTypes.ProjectService, {
  one: 'Service',
  many: 'Services',
  matchingPropertyNames: ['project-services', 'project-service', 'services'],
});

labels.set(ModelTypes.ProjectUnit, {
  one: 'Unit',
  many: 'Units',
  matchingPropertyNames: ['project-units', 'project-unit', 'unit'],
});

labels.set(ModelTypes.FeatureEvidTimer, {
  one: 'Evid Timer',
  many: 'Evid Timers',
  matchingPropertyNames: ['evid_timer_types'],
});
labels.set(ModelTypes.FeatureEvidVid, {
  one: 'Evid Vid',
  many: 'Evid Vids',
  matchingPropertyNames: ['evid_vid_types'],
});
labels.set(ModelTypes.FeatureEvidFunction, {
  one: 'Evid function',
  many: 'Evid functions',
  matchingPropertyNames: ['evid-function', 'evid-functions', 'evid_function_types', 'feature_evid_function_types'],
});
labels.set(ModelTypes.Feature, {
  one: 'Feature',
  many: 'Features',
  matchingPropertyNames: ['feature'],
});
labels.set(ModelTypes.Unit, {
  one: 'Unit',
  many: 'Units',
  matchingPropertyNames: ['units', 'feature-units'],
});
labels.set(ModelTypes.Service, {
  one: 'Service',
  many: 'Services',
  matchingPropertyNames: ['feature_service_types', 'feature_service_type', 'service_types', 'service_type'],
});
labels.set(ModelTypes.Port, {
  one: 'Port',
  many: 'Ports',
  matchingPropertyNames: ['feature_port_types', 'feature_port_type', 'port_types', 'port_type'],
});

labels.set(ModelTypes.GgwImplementationType, {
  one: 'GGW Impl',
  many: 'GGW Impls',
  matchingPropertyNames: [
    'ggw_implementation_types',
    'ggw_implementation_type',
  ],
});
labels.set(ModelTypes.Parameter, {
  one: 'Parameter',
  many: 'Parameter',
  matchingPropertyNames: ['feature_parameter', 'feature_parameters', 'parameters', 'parameter'],
});
labels.set(ModelTypes.AudioParameters, {
  one: 'Audio Parameter',
  many: 'Audio Parameter',
  matchingPropertyNames: ['feature_audio_parameters', 'feature_audio_parameter', 'audio_parameters', 'audio_parameter'],
});
labels.set(ModelTypes.GgwDeviceType, {
  one: 'GGW Device',
  many: 'GGW Devices',
  matchingPropertyNames: [
    'feature_ggw_device_types',
    'feature_ggw_device_type',
    'ggw_device_types',
    'ggw_device_type',
    'ggw_devices',
  ],
});
labels.set(ModelTypes.GgwFixedRoute, {
  one: 'Fixed Route',
  many: 'Fixed Routes',
  matchingPropertyNames: ['feature_ggw_fixed_routes', 'feature_ggw_fixed_route', 'ggw_fixed_routes', 'ggw_fixed_route'],
});
labels.set(ModelTypes.FeatureGgwDynamicRouteTemplates, {
  one: 'Dynamic Route Template',
  many: 'Dynamic Route Templates',
  matchingPropertyNames: ['ggw_dynamic_route_templates'],
});
labels.set(ModelTypes.FeatureOptionTokens, {
  one: 'Option Token',
  many: 'Option Tokens',
  matchingPropertyNames: ['option_tokens'],
});
labels.set(ModelTypes.ProjectEvidFunctions, {
  one: 'Evid Function',
  many: 'Evid Functions',
  matchingPropertyNames: ['evid_function', 'evid_functions'],
});
labels.set(ModelTypes.FeatureAvodCatalogs, {
  one: 'AVoD Catalog',
  many: 'AVoD Catalogs',
  matchingPropertyNames: ['avod_catalogs'],
});
labels.set(ModelTypes.ProjectAvodCatalogs, {
  one: 'AVoD Catalog',
  many: 'AVoD Catalogs',
  matchingPropertyNames: ['avod_catalogs', 'project_avod_catalogs'],
});



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/core/utils/json-schema/type-label-mapping.ts